<template>
    <modal name="finding-content-popup" height="auto" width="90%" :max-width="525" :adaptive="true" :scrollable="true">
        <div class="finding-content-modal">
            <div class="finding-content-modal__headline">
                <span v-html="$t('FindingContentModal.title')" class="finding-content-modal__title"></span>
                <span class="icon-cancel finding-content-modal__close-button" @click="closeModal"></span>
            </div>
            <ul class="finding-content-modal__feature-list">
                <li >
                    <span class="finding-content-modal__item" v-html="$t('FindingContentModal.paragraph')"></span>
                </li>
            </ul>
            <div class="finding-content-modal__image-box" v-if="isDesktopView">
                <img
                    :src="require('@/assets/images/featuremodals/finding-content.png')"
                    alt="" class="finding-content-modal__image"
                />
            </div>
            <TotemButton
                color="dark-orange"
                @click="closeModal"
                class="finding-content-modal__ask-for-quotation-button"
                :label="$t('FindingContentModal.button')"
            />
        </div>
    </modal>
</template>
<script>
export default {
    name: 'modal-finding-content',
    methods: {
        closeModal () {
            this.$modal.hide('finding-content-popup')
        }
    }
}
</script>
<style lang="scss" scoped>
.finding-content-modal {
    border: 0;
    border-radius: 10px 10px 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &__headline {
        font-family: Quicksand-Regular, sans-serif;
        font-size: 1.8rem;
        font-weight: 700;
        padding: 25px 20px;
        background: $rust_orange;
        color: $white;
        width: 100%;
        justify-content: space-between;
        flex-direction: row;
        display: flex;
        gap: 15px;
    }
    &__close-button {
        float: right;
        font-size: 2.4rem;
        cursor: pointer;
    }
    &__title {
        text-align: left;
    }
    &__image-box {
        align-self: center;
        display: flex;
        width: 100%;
        padding: 20px 0;
    }
    &__image {
        margin: 0 auto;
    }
    &__feature-list {
        font-size: 1.8rem;
        padding: 20px 20px;
        li {
            margin: 0 0 15px 0;
            display: flex;
            &:last-of-type {
                margin: 0;
            }
        }
    }
    &__item {
        font-family: Nunito-Regular, sans-serif;
    }
    &__ask-for-quotation-button {
        align-self: center;
        margin: 0 0 30px;
        [class*="desktop"] & {
            margin: 30px 0;
        }
    }
}
</style>
<style lang="scss">
[data-modal=finding-content-popup] {
    .v--modal-box.v--modal {
        border-radius: 15px !important;
    }
}
</style>
